import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/auth-store'
import { AuthProvider } from '@/providers/auth-provider'
import { Shell } from '@/components/layout/shell'
import LoginPage from '@/pages/login'
import DashboardPage from '@/pages/dashboard'
import TenantsPage from '@/pages/tenants/index'
import CreateTenantPage from '@/pages/tenants/create'
import TenantDetailPage from '@/pages/tenants/detail'
import PlansPage from '@/pages/plans/index'
import AnalyticsPage from '@/pages/analytics'
import ComponentsPage from '@/pages/components/index'
import CreateComponentPage from '@/pages/components/create'
import ComponentDetailPage from '@/pages/components/detail'
import RegistrationsPage from '@/pages/registrations/index'
import UpgradeRequestsPage from '@/pages/upgrade-requests/index'
import PlatformSettingsPage from '@/pages/platform-settings/index'
import ThemePresetsPage from '@/pages/theme-presets/index'
import CreateThemePresetPage from '@/pages/theme-presets/create'
import EditThemePresetPage from '@/pages/theme-presets/edit'

function RequireAdmin({ children }: { children: React.ReactNode }) {
  const session = useAuthStore((s) => s.session)
  const isPlatformAdmin = useAuthStore((s) => s.isPlatformAdmin)

  if (!session || !isPlatformAdmin) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <RequireAdmin>
                <Shell />
              </RequireAdmin>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route path="tenants" element={<TenantsPage />} />
            <Route path="tenants/create" element={<CreateTenantPage />} />
            <Route path="tenants/:id" element={<TenantDetailPage />} />
            <Route path="plans" element={<PlansPage />} />
            <Route path="components" element={<ComponentsPage />} />
            <Route path="components/create" element={<CreateComponentPage />} />
            <Route path="components/:id" element={<ComponentDetailPage />} />
            <Route path="registrations" element={<RegistrationsPage />} />
            <Route path="upgrade-requests" element={<UpgradeRequestsPage />} />
            <Route path="theme-presets" element={<ThemePresetsPage />} />
            <Route path="theme-presets/create" element={<CreateThemePresetPage />} />
            <Route path="theme-presets/:id" element={<EditThemePresetPage />} />
            <Route path="analytics" element={<AnalyticsPage />} />
            <Route path="platform-settings" element={<PlatformSettingsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  )
}
